import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, useIntl} from "react-intl";

import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";

import {getCommonVisualizerType} from "../../../config";


const LookSideBarAIPanelFinishedRenderPopper = (props) => {

  const {lookAiRenderFinished, anchorRef} = props;

  const placement = "right";
  const intl = useIntl();
  const visualizerTypeTranslate = intl.formatMessage({id: "rooms." + getCommonVisualizerType()});

  return (
    <Popper open={lookAiRenderFinished}
            className={"look-step look-step--" + placement}
            anchorEl={anchorRef.current}
            placement={placement}
            transition
            disablePortal>
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: placement === "right" ? "right center" : "left center" }}>
          <div className="look-step__content">
              <span className={"look-step__content-text text-uppercase look-step__content-text--" + placement}>
                <FormattedMessage id="look.ai.finished.text" values={{
                  visualizerType: visualizerTypeTranslate
                }}/>
              </span>
          </div>
        </Grow>
      )}
    </Popper>
  )
};

const mapStateToProps = (store) => {
  const {lookAiRenderFinished} = store.aiState;

  return {
    lookAiRenderFinished,
  };
};

export default connect(mapStateToProps)(LookSideBarAIPanelFinishedRenderPopper)
